// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  developer: {
    api_base_url: 'https://developer-qa.delivergate.com'
  },
  report: {
    api_base_url: 'https://reporting-qa.delivergate.com'
  },
  data_ai: {
    api_base_url: 'https://dg-recommendation-system.delivergate.com'
  },
  logo_url: "https://delivergate-logos.s3.eu-west-2.amazonaws.com/delivergate.png",
  CLIENT_ID: 1,
  CLIENT_SECRET: 'kVkfbFaqrCSWRdh8EuEkAO1kFN7ALmiuWS8KSDZd',
  GRANT_TYPE: 'password',
  app_version: 'v 1.0.9',
  currency: "£"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
